import { render } from "./OffersView.vue.ts?vue&type=template&id=dbbc3964&ts=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./OffersView.vue?vue&type=template&id=dbbc3964&ts=true"
import script from "./OffersView.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./OffersView.vue?vue&type=script&setup=true&lang=ts"
export * from "./OffersView.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./OffersView.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/apps/merchant3/views/OffersView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dbbc3964"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dbbc3964', __exports__)) {
    api.reload('dbbc3964', __exports__)
  }
  
  module.hot.accept("./OffersView.vue.ts?vue&type=template&id=dbbc3964&ts=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./OffersView.vue?vue&type=template&id=dbbc3964&ts=true", () => {
    api.rerender('dbbc3964', render)
  })

}


export default __exports__